// Each pack keeps its own native Shopify product form and payment buttons.
const panelSelector = '[data-dobs-landing-panel]';
const legacyLandingHashes = ['#dobs-reviews'];

function isLegacyLandingHash(hash) {
  return legacyLandingHashes.includes(hash) || hash.startsWith('#DobsProduct-');
}

function clearLandingScrollState() {
  const currentState = typeof history.state === 'object' && history.state !== null ? { ...history.state } : {};
  delete currentState.scrollTop;

  const url = isLegacyLandingHash(window.location.hash)
    ? `${window.location.pathname}${window.location.search}`
    : undefined;
  window.history.replaceState(currentState, '', url);
}

function resetLandingScroll() {
  document.querySelector('.page-wrapper')?.scrollTo({ top: 0, behavior: 'instant' });
  document.scrollingElement?.scrollTo({ top: 0, behavior: 'instant' });
}

// Always open the landing page at the product. Old pack/review anchors are also
// removed before the theme's scroll-restoration code can move the page.
history.scrollRestoration = 'manual';
clearLandingScrollState();
resetLandingScroll();
window.addEventListener('pageshow', resetLandingScroll, { once: true });

function showPack(panel, moveFocus = false) {
  const panels = [...document.querySelectorAll(panelSelector)];
  for (const item of panels) {
    const section = item.closest('.shopify-section');
    item.hidden = item !== panel;
    if (section) section.hidden = item !== panel;
  }

  const reviewUrl = `${panel.dataset.dobsProductUrl}#judgeme_product_reviews`;
  const reviewLabel = `${panel.dataset.dobsProductTitle} bewerten`;
  for (const link of document.querySelectorAll('[data-dobs-review-link]')) {
    link.href = reviewUrl;
    const label = link.querySelector('[data-dobs-review-link-label]');
    if (label) label.textContent = reviewLabel;
  }

  if (moveFocus) {
    panel.querySelector('[data-dobs-pack-link][aria-current="true"]')?.focus({ preventScroll: true });
  }
}

function initializePacks() {
  const panels = [...document.querySelectorAll(panelSelector)];
  if (!panels.length) return;
  const defaultPanel = panels.find((panel) => panel.dataset.dobsDefault === 'true');
  showPack(defaultPanel || panels[0]);
  document.documentElement.classList.add('dobs-landing-ready');
}

function setReviewsExpanded(section, expanded) {
  const toggle = section.querySelector('[data-dobs-reviews-toggle]');
  if (!toggle) return;

  for (const review of section.querySelectorAll('[data-dobs-review-extra]')) {
    review.hidden = !expanded;
  }

  toggle.setAttribute('aria-expanded', String(expanded));
  const label = toggle.querySelector('[data-dobs-reviews-toggle-label]');
  if (label) label.textContent = expanded ? toggle.dataset.expandedLabel : toggle.dataset.collapsedLabel;
}

function initializeReviews(root = document) {
  for (const section of root.querySelectorAll('[data-dobs-reviews]')) {
    const toggle = section.querySelector('[data-dobs-reviews-toggle]');
    const toggleWrap = section.querySelector('[data-dobs-reviews-toggle-wrap]');
    const extraReviews = section.querySelectorAll('[data-dobs-review-extra]');
    if (!toggle || !toggleWrap || !extraReviews.length) continue;

    setReviewsExpanded(section, false);
    toggleWrap.hidden = false;
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const videoThumbnail = event.target.closest('[data-dobs-video-thumbnail]');
  if (videoThumbnail) {
    const slideshow = videoThumbnail.closest('slideshow-component');
    if (typeof slideshow?.select === 'function') {
      event.preventDefault();
      slideshow.select(2, event, { animate: false });
    }
    return;
  }

  const link = event.target.closest('[data-dobs-pack-link]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const panel = document.getElementById(link.hash.slice(1))?.closest(panelSelector);
  if (!panel) return;

  event.preventDefault();
  showPack(panel, true);
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const toggle = event.target.closest('[data-dobs-reviews-toggle]');
  if (toggle) {
    const reviews = toggle.closest('[data-dobs-reviews]');
    if (reviews) setReviewsExpanded(reviews, toggle.getAttribute('aria-expanded') !== 'true');
    return;
  }

  const link = event.target.closest('[data-dobs-reviews-link]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const reviews = document.querySelector('#dobs-reviews');
  if (!reviews) return;

  event.preventDefault();
  reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

document.addEventListener('shopify:section:load', (event) => {
  initializePacks();
  initializeReviews(event.target);
});
document.addEventListener('shopify:section:select', (event) => {
  if (!(event.target instanceof Element)) return;
  const panel = event.target.querySelector(panelSelector);
  if (panel) showPack(panel);
});

initializePacks();
initializeReviews();
